import {apiAction} from './api'
import {
  CREATE_USER_ACCOUNT,
  LOGIN_USER,
  VERIFICATION,
  RESEND_VERIFICATION,
  RESET_PASSWORD,
  CHANGE_PASSWORD,
  ADD_NEW_INVITEE,
  SET_METADATA,
  GET_MAIL_BOX,
  UPDATE_SMTP_SETTINGS,
  RESEND_INVITATION,
  GET_VERIFICATION,
  SET_PASSWORD,
  VERIFY_DOMAIN,
  FORGOT_DOMAIN,
  LOGOUT,
  CHANGE_EMAIL,
  PRODUCT_SUBSCRIBE,
  PRODUCT_SUBSCRIBE_DETAILS,
  GLOBAL_SEARCH,
  INITIAL_DATA,
  PRODUCT_VERIFY_TOKEN,
  LEARN_MORE,
} from './types'

import * as endpoint from './endpoint'

// -- createUserAccount ---//

export function createUserAccount(data) {
  //
  return apiAction({
    url: endpoint.USER_ACCOUNTS,
    method: 'POST',
    label: CREATE_USER_ACCOUNT,
    data,
    isTokenSkipped: true,
    showToast: true,
  })
}

// ----Reset Password---/
// ---migration pending---//
export function otpRequest(data) {
  return apiAction({
    url: `${endpoint.USER_ACCOUNTS}/forgotpassword`,
    method: 'POST',
    label: RESET_PASSWORD,
    data,
    showToast: true,
    isTokenSkipped: true,
  })
}

// ----Reset Password OTP---/

// ----Change Password ---/
// ---migration pending---//
export function changePassword(data) {
  //
  return apiAction({
    url: `${endpoint.USER_ACCOUNTS}/setpassword`,
    method: 'POST',
    label: CHANGE_PASSWORD,
    data,
    showToast: true,
    isTokenSkipped: true,
  })
}

// -- logInUser --//

export function logInUser(data) {
  return apiAction({
    url: `${endpoint.USER_ACCOUNTS}/login`,
    method: 'POST',

    label: LOGIN_USER,
    data,
    isTokenSkipped: true,
    showToast: true,
  })
}

// -- userVerification ---//

export function userVerification(data) {
  return apiAction({
    url: `${endpoint.USER_VERIFICATIONS}/verifyotp`,
    method: 'POST',
    label: VERIFICATION,
    data,
    showToast: true,
    isTokenSkipped: true,
  })
}

export function signupVerification(data) {
  return apiAction({
    url: `${endpoint.USER_VERIFICATIONS}/signup-otp-verify`,
    method: 'POST',
    label: VERIFICATION,
    data,
    showToast: true,
    isTokenSkipped: true,
  })
}

// -- Email Change after opt send ---//

export function changeEmail(data) {
  return apiAction({
    url: `${endpoint.USER_PLATFORM_V1}/email`,
    method: 'PUT',
    label: CHANGE_EMAIL,
    data,
    showToast: true,
    successMessage: 'Email Changed Successfully',
    isTokenSkipped: true,
  })
}

// Verfication status of account

export function getVerification(data) {
  return apiAction({
    url: `${endpoint.USER_VERIFICATIONS}?requestId=${data}`,
    method: 'GET',
    label: GET_VERIFICATION,
    showToast: true,
    isTokenSkipped: true,
  })
}

// -- resendVerification ---//
export function resendVerification(data) {
  return apiAction({
    url: `${endpoint.USER_VERIFICATIONS}/resend?requestId=${data}`,
    method: 'GET',
    label: RESEND_VERIFICATION,
    showToast: true,
    isTokenSkipped: true,
  })
}

export function resendSignupOTPVerification(data) {
  return apiAction({
    url: `${endpoint.USER_VERIFICATIONS}/resend-signup-otp?requestId=${data}`,
    method: 'GET',
    label: RESEND_VERIFICATION,
    showToast: true,
    isTokenSkipped: true,
  })
}

// Set Password
// ---migration pending---//
export function setPassword(data) {
  return apiAction({
    url: `${endpoint.USER_ACCOUNTS}/setpassword`,
    method: 'POST',
    label: SET_PASSWORD,
    data,
    showToast: true,
    isTokenSkipped: true,
  })
}

// Add New Invitee

export function addNewInvitee(inviteeData) {
  return apiAction({
    url: `${endpoint.USER_ACCOUNTS}/users`,
    method: 'POST',
    label: ADD_NEW_INVITEE,
    data: inviteeData,
    showToast: true,
    successMessage: 'User Added',
  })
}

// -----Getting Started Status ----///
export function setMetaData(data) {
  return apiAction({
    url: `${endpoint.USER_ACCOUNTS}/metadata`,
    method: 'PUT',
    label: SET_METADATA,
    data,
  })
}

// ---migration pending---//
export function getMetaData() {
  return apiAction({
    url: `${endpoint.USER_ACCOUNTS}/metadata`,
    method: 'GET',
    label: 'GET_META_DATA',
  })
}

export function getMailBox(data) {
  return apiAction({
    url: `${endpoint.DESK_MAILBOXES}/${data}`,
    method: 'GET',
    label: GET_MAIL_BOX,
  })
}

export function resendInvitation(id) {
  return apiAction({
    url: `${endpoint.USER_VERIFICATIONS}/resend?userId=${id}`,
    method: 'GET',
    label: RESEND_INVITATION,
    showToast: true,
    successMessage: 'Invitation sent',
  })
}

export function setSMTPSetting(data, mailBoxId) {
  return apiAction({
    url: `${endpoint.DESK_MAILBOXES}/${mailBoxId}/smtp`,
    method: 'PUT',
    label: UPDATE_SMTP_SETTINGS,
    data,
    showToast: true,
  })
}

export function domainVerification(data) {
  return apiAction({
    url: `${endpoint.USER_ACCOUNTS}/domain`,
    method: 'POST',
    label: VERIFY_DOMAIN,
    data,
    errorMessage: 'Invalid Domain',
    showToast: true,
  })
}

export function forgotDomain(data) {
  return apiAction({
    url: `${endpoint.USER_ACCOUNTS}/forgotdomain`,
    method: 'POST',
    label: FORGOT_DOMAIN,
    data,
    showToast: true,
  })
}

export function logoutCall() {
  return apiAction({
    url: `${endpoint.USER_ACCOUNTS}/logout`,
    method: 'POST',
    label: LOGOUT,
  })
}

export function productSubscribeDetails() {
  return apiAction({
    url: `${endpoint.USER_ACCOUNTS}/billing/subscriptions/products`,
    method: 'GET',
    label: PRODUCT_SUBSCRIBE_DETAILS,
  })
}

export function productSubscribe(data) {
  return apiAction({
    url: `${endpoint.USER_ACCOUNTS}/subscribe/product`,
    method: 'POST',
    label: PRODUCT_SUBSCRIBE,
    data,
    showToast: true,
    successMessage: 'Product Subscribe Successfully',
  })
}

export function productVerifyToken(data) {
  return apiAction({
    url: `${endpoint.USER_PLATFORM_V1}/verfyToken`,
    method: 'POST',
    label: PRODUCT_VERIFY_TOKEN,
    data,
    showToast: true,
  })
}

export function globalSearch(value) {
  return apiAction({
    url: `${endpoint.DESK_DESK}/search?text=${value}`,
    method: 'GET',
    label: GLOBAL_SEARCH,
  })
}

export function helpLearnMore() {
  return apiAction({
    url: `${endpoint.DESK_DESK}/help-learnmore/urls`,
    method: 'GET',
    label: LEARN_MORE,
  })
}

export function initialdata() {
  return apiAction({
    url: `${endpoint.USER_PLATFORM_V1}/me`,
    method: 'GET',
    label: INITIAL_DATA,
  })
}

export {
  sendNote,
  sendEmail,
  moveConversationTo,
  getMailBoxConversation,
  getConversation,
  updateConversation,
  snoozeConversation,
  updateConversationStatus,
  deleteMessageOfConversation,
  getSearchedMailBoxConversation,
  mergeConversation,
  splitConversation,
  permanentDeleteConversation,
} from './inbox'
export {
  getContactList,
  getContactDetails,
  deleteContact,
  createContact,
  editContact,
  addLabelToContact,
  addNoteInContacts,
} from './contacts'

export {
  getKnowledgebase,
  createKnowledgebase,
  getCategories,
  updateCategory,
  deleteCategory,
  createCategory,
  getArticlesByDoc,
  getArticlesByCategory,
  createArticle,
  updateArticle,
  updateDocDetails,
  deleteArticle,
  getCategoryDetails,
  getArticleDetail,
} from './knowledgebase'
